var _path, _path2, _path3, _ellipse, _circle, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9642 17.3637L6.7173 44.4096C6.14554 46.5435 7.41187 48.7368 9.54573 49.3086L55.9102 61.7319C58.044 62.3037 60.2374 61.0374 60.8091 58.9035L68.0561 31.8576C68.6278 29.7237 67.3615 27.5304 65.2277 26.9586L18.8632 14.5353C16.7294 13.9635 14.536 15.2298 13.9642 17.3637Z",
    fill: "#A6B6EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30.5V58.5C10 60.7091 11.7909 62.5 14 62.5H62C64.2091 62.5 66 60.7091 66 58.5V30.5C66 28.2909 64.2091 26.5 62 26.5H14C11.7909 26.5 10 28.2909 10 30.5Z",
    fill: "#C1CCF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 35.5C16.3137 35.5 19 32.8137 19 29.5L57 29.5C57 32.8137 59.6863 35.5 63 35.5V53.5C59.6863 53.5 57 56.1863 57 59.5H19C19 56.1863 16.3137 53.5 13 53.5V35.5Z",
    fill: "#E0E5FB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 44.5,
    rx: 8,
    ry: 8.00002,
    fill: "#C1CCF4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62.5,
    r: 10,
    fill: "#17C5D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 58.5C63.25 59.1904 62.6904 59.75 62 59.75C61.3096 59.75 60.75 59.1904 60.75 58.5C60.75 57.8096 61.3096 57.25 62 57.25C62.6904 57.25 63.25 57.8096 63.25 58.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62V66.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.add6f5e66c665f060252e99c7748301b.svg";
export { ForwardRef as ReactComponent };